import { Suspense, useRef, useState, useEffect } from "react";
import { Canvas} from "@react-three/fiber";
import {
  AdaptiveDpr,
  Environment,
  useProgress,
  Html,
  OrbitControls,
  Sky,
} from "@react-three/drei";
import { Leva } from "leva";
import { useStore } from "./hooks/useStore";
import { ShivaModel } from "./components/Water/Grass/Natrang/Shiva";
import Grass from "./components/Water/Grass/Grass";
import { PinkTreeModel } from "./components/Water/Grass/Natrang/PinkTree";
import { EffectComposer, Bloom, GodRays } from "@react-three/postprocessing";

function WaterScene() {
  const ready = useStore((state) => state.ready);

  // function Ocean() {
  //   const ref = useRef();
  //   const gl = useThree((state) => state.gl);
  //   const waterNormals = useLoader(THREE.TextureLoader, "/waternormals.jpeg");
  //   waterNormals.wrapS = waterNormals.wrapT = THREE.RepeatWrapping;
  //   const geom = useMemo(() => new THREE.PlaneGeometry(10000, 10000), []);
  //   const config = useMemo(
  //     () => ({
  //       textureWidth: 512,
  //       textureHeight: 512,
  //       waterNormals,
  //       sunDirection: new THREE.Vector3(),
  //       sunColor: 0xffffff,
  //       waterColor: 0x54b6ff,
  //       distortionScale: 3.7,
  //       fog: false,
  //       format: gl.encoding,
  //       time: 0.001,
  //     }),
  //     [waterNormals]
  //   );
  //   useFrame(
  //     (state, delta) => (ref.current.material.uniforms.time.value += delta)
  //   );
  //   return (
  //     <water
  //       position={[0, 0, 0]}
  //       ref={ref}
  //       args={[geom, config]}
  //       rotation-x={-Math.PI / 2}
  //     />
  //   );
  // }

  const sunRef = useRef(null);
  const [sun, setSun] = useState(null);

  useEffect(() => {
    if (sunRef.current) {
      setSun(sunRef.current);
    }
  }, []);

  function Loader() {
    const { progress } = useProgress();
    return (
      <Html center zIndexRange={[10, 10]}>
        <div className="w-screen h-screen bg-black loader z-20">
          <div className="progress-bar" style={{ width: `${progress}%` }} />
        </div>
      </Html>
    );
  }

  return (
    <>
      <Suspense>
        <div className={"w-screen h-screen"}>
          <Leva hidden={!ready} />
          <Canvas
            camera={{ position: [30, 10, -30], fov: 35, far: 10000 }}
            shadows={true}
          >
            <Environment backgroundIntensity={0.4} preset="dawn" />
            <Sky
              distance={40}
              sunPosition={[0, 10, 0.01]}
              inclination={0}
              azimuth={-180}
            />
            {/* <CameraController /> */}
            <Suspense fallback={<Loader />}>
              {/* <Scene /> */}
              <ShivaModel />
              <Grass />
              <PinkTreeModel scale={1} position={[-14, 3, -10]} />
              <PinkTreeModel scale={1} position={[8, 3, -2]} />
              {/* <Ocean /> */}
              {/* <IslandModel /> */}
              <mesh position={[0, 3, 0]} rotation={[-Math.PI / 2, 0, 0]}>
                <planeGeometry args={[50, 50]} />
                <meshBasicMaterial color={"#261203"} />
              </mesh>
              <mesh ref={sunRef} scale={15} position={[0, 0, -100]}>
                <sphereGeometry args={[1, 64, 64]} />
                <meshPhysicalMaterial
                  color="white"
                  emissive="orange"
                  emissiveIntensity={0.3}
                  toneMapped={false}
                />
              </mesh>
              {sunRef.current && (
                <EffectComposer>
                  <GodRays
                    sun={sunRef.current}
                    density={1.016}
                    decay={0.93}
                    weight={0.9}
                    exposure={0.9}
                  />
                  <Bloom
                    intensity={0.1}
                    luminanceThreshold={0.2}
                    luminanceSmoothing={0.5}
                  />
                </EffectComposer>
              )}
            </Suspense>
            {/* <Experience /> */}
            <OrbitControls />
            <AdaptiveDpr pixelated />
          </Canvas>
        </div>
      </Suspense>
    </>
  );
}

export default WaterScene;
